import signedFetch from '../util/signedFetch';

export default function* getChatbotResponse({ question, history, topic }) {
  return yield signedFetch('getChatbotResponse', `${__API_BASE__}/chat/oup/staff/help`, 'POST', {
    question,
    history,
    topic
  });
}
